import React, {useState} from 'react';
import styled from 'styled-components';
import {Link} from 'gatsby';

import NavList from './NavList';
import NavBurger from './NavBurger';

import logos from '../../assets/images/Logo.svg';

const NavigationWrapper = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100vw; 
    height: 12vh;
    padding: 0 8vw;
    background-color: white;
    z-index: 90;
    box-shadow: 1px 2px 10px rgba(129, 53, 53, 0.2);
`;

const NavLogo = styled.img`
    height: 60%; 
    width: auto;
`;


const Navigation = () => {
    const [open, setOpen] = useState(false);

    return (
    <NavigationWrapper>
        <Link to="/">
        <NavLogo src={logos}/>
        </Link>
        <NavBurger open={open} clickFunc = {() => setOpen(!open)} />
        <NavList open={open}/>
    </NavigationWrapper>
    )
    }

export default Navigation